"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogLevelLogProvider_1 = require("./Log/Port/LogLevelLogProvider");
const LogManager_1 = require("./Log/LogManager");
LogManager_1.logManager.Init(LogLevelLogProvider_1.logLevelLogProvider);
const Langyan_1 = require("./Engine/Langyan");
exports.Langyan = Langyan_1.Langyan;
exports.LangyanErrorName = Langyan_1.LangyanErrorName;
exports.LangyanSignalingNotStableError = Langyan_1.LangyanSignalingNotStableError;
exports.LangyanSignalingNotAvailableError = Langyan_1.LangyanSignalingNotAvailableError;
exports.LangyanError = Langyan_1.LangyanError;
const ClientCommandHub_1 = require("./Engine/Command/Port/ClientCommandHub");
const ClientEventHub_1 = require("./Engine/Event/Port/ClientEventHub");
//user
const Contact_1 = require("./RtcUser/Contact");
exports.Contact = Contact_1.Contact;
const UserDto_1 = require("./RtcUser/Protocol/UserDto");
exports.UserDto = UserDto_1.UserDto;
const UserEvent_1 = require("./RtcUser/UserEvent");
exports.UserEvent = UserEvent_1.UserEvent;
const UserMemRepository_1 = require("./RtcUser/Port/UserMemRepository");
const UserClientApplicationService_1 = require("./RtcUser/UserClientApplicationService");
exports.UserClientApplicationService = UserClientApplicationService_1.UserClientApplicationService;
exports.UserApplicationServiceError = UserClientApplicationService_1.UserApplicationServiceError;
exports.UserApplicationServiceErrorName = UserClientApplicationService_1.UserApplicationServiceErrorName;
//chat
const ChatMessageDto_1 = require("./RtcChat/Protocol/ChatMessageDto");
exports.ChatMessageDto = ChatMessageDto_1.ChatMessageDto;
const ChatDto_1 = require("./RtcChat/Protocol/ChatDto");
exports.ChatDto = ChatDto_1.ChatDto;
const ChatEvent_1 = require("./RtcChat/ChatEvent");
exports.ChatEvent = ChatEvent_1.ChatEvent;
const ChatMessageAttachmentHttpService_1 = require("./RtcChat/Port/ChatMessageAttachmentHttpService");
const ChatFactory_1 = require("./RtcChat/Port/ChatFactory");
const ChatMessageDefinition_1 = require("./RtcChat/ChatMessageDefinition");
exports.ChatMessageDefinition = ChatMessageDefinition_1.ChatMessageDefinition;
const ChatClientApplicationService_1 = require("./RtcChat/ChatClientApplicationService");
exports.ChatClientApplicationService = ChatClientApplicationService_1.ChatClientApplicationService;
exports.ChatApplicationServiceError = ChatClientApplicationService_1.ChatApplicationServiceError;
exports.ChatApplicationServiceErrorName = ChatClientApplicationService_1.ChatApplicationServiceErrorName;
//Session
const SessionDefinition_1 = require("./RtcSession/SessionDefinition");
exports.SessionType = SessionDefinition_1.SessionType;
const Attendee_1 = require("./RtcSession/Protocol/Attendee");
exports.Attendee = Attendee_1.Attendee;
exports.Creator = Attendee_1.Creator;
const SessionDto_1 = require("./RtcSession/Protocol/SessionDto");
exports.SessionDto = SessionDto_1.SessionDto;
const SessionTicket_1 = require("./RtcSession/Protocol/SessionTicket");
exports.SessionTicket = SessionTicket_1.SessionTicket;
const SessionEvent_1 = require("./RtcSession/SessionEvent");
exports.SessionEvent = SessionEvent_1.SessionEvent;
const SessionMemRepository_1 = require("./RtcSession/Port/SessionMemRepository");
const SessionClientFactory_1 = require("./RtcSession/Port/SessionClientFactory");
const ISessionApplicationService_1 = require("./RtcSession/ISessionApplicationService");
exports.SessionApplicationServiceErrorName = ISessionApplicationService_1.SessionApplicationServiceErrorName;
exports.SessionApplicationServiceError = ISessionApplicationService_1.SessionApplicationServiceError;
const SessionClientApplicationService_1 = require("./RtcSession/SessionClientApplicationService");
exports.SessionClientApplicationService = SessionClientApplicationService_1.SessionClientApplicationService;
//Fudao
const FudaoDefinition_1 = require("./Fudaos/FudaoDefinition");
exports.FudaoSession = FudaoDefinition_1.FudaoSession;
const FudaoDto_1 = require("./Fudaos/Protocol/FudaoDto");
exports.FudaoDto = FudaoDto_1.FudaoDto;
const FudaoUser_1 = require("./Fudaos/FudaoUser");
exports.FudaoUser = FudaoUser_1.FudaoUser;
const FudaoEvent_1 = require("./Fudaos/FudaoEvent");
exports.FudaoEvent = FudaoEvent_1.FudaoEvent;
const FudaoMemRepository_1 = require("./Fudaos/Port/FudaoMemRepository");
const FudaoClientFactory_1 = require("./Fudaos/Port/FudaoClientFactory");
const FudaoPassedTimeCounter_1 = require("./Fudaos/FudaoPassedTimeCounter");
const FudaoPassportService_1 = require("./Fudaos/Port/FudaoPassportService");
const FudaoHttpCommandHubAdapter_1 = require("./Fudaos/Port/FudaoHttpCommandHubAdapter");
const FudaoSessionFacade_1 = require("./Fudaos/Port/FudaoSessionFacade");
const FudaoClientApplicationServiceBase_1 = require("./Fudaos/FudaoClientApplicationServiceBase");
exports.FudaoApplicationServiceErrorName = FudaoClientApplicationServiceBase_1.FudaoApplicationServiceErrorName;
exports.FudaoApplicationServiceError = FudaoClientApplicationServiceBase_1.FudaoApplicationServiceError;
const FudaoClientApplicationService_1 = require("./Fudaos/FudaoClientApplicationService");
exports.FudaoClientApplicationService = FudaoClientApplicationService_1.FudaoClientApplicationService;
const FudaoEventToChatAdapter_1 = require("./Fudaos/Port/FudaoEventToChatAdapter");
const ChatMessageAttachmentIndexedDbStore_1 = require("./RtcChat/Port/ChatMessageAttachmentIndexedDbStore");
const ChatsDatabase_1 = require("./RtcChat/Port/ChatsDatabase");
const ChatIndexedDbRepository_1 = require("./RtcChat/Port/ChatIndexedDbRepository");
let cmdHub;
let evtHub;
let userRepo;
let cmAttachmentStore;
let chatFactory;
let chatRepo;
let sessionFactory;
let sessionRepo;
let fudaoRepo;
let fudaoPassedTimeCounter;
let fudaoSessionFacade;
let fudaoHttpCmdHubAdapter;
let fudaoFactory;
let fudaoPassportService;
let fudaoEventToChatAdapter;
exports.initAsync = async (initPara) => {
    const webSyncServerUrl = initPara.webSyncServerUrl;
    const iceLinkServerAddress = initPara.iceLinkServerAddress;
    const userId = initPara.userId;
    const userName = initPara.userName;
    const token = initPara.token;
    const chatServiceUrl = initPara.chatServiceUrl;
    const importedWebSync = initPara.websync;
    const fudaoServiceUrl = initPara.fudaoServiceUrl;
    if (initPara.log)
        LogLevelLogProvider_1.logLevelLogProvider.Init(initPara.log);
    if (!exports.langyan) {
        //using same object during application life cycle. because Signalling needs to be reuse.
        exports.langyan = new Langyan_1.Langyan({ webSyncServerUrl, iceLinkServerAddress });
    }
    await exports.langyan.initAsync({ userId, userName, token, requestTimeout: 30000, importedWebSync });
    cmdHub = new ClientCommandHub_1.ClientCommandHub(exports.langyan);
    await cmdHub.initAsync({ id: userId, name: userName });
    evtHub = new ClientEventHub_1.ClientEventHub(exports.langyan);
    await evtHub.initAsync(userId, userName);
    //init user domain
    userRepo = new UserMemRepository_1.UserMemRepository(cmdHub, evtHub);
    exports.userAppService = new UserClientApplicationService_1.UserClientApplicationService(exports.langyan, userRepo, cmdHub, evtHub);
    const userDto = new UserDto_1.UserDto({
        id: userId,
        username: userName,
    });
    await exports.userAppService.initAsync(userDto);
    //init chat domain
    const chatsDb = new ChatsDatabase_1.ChatsDatabase(userId);
    //cmAttachmentStore = new ChatMessageAttachmentMemStore();
    cmAttachmentStore = new ChatMessageAttachmentIndexedDbStore_1.ChatMessageAttachmentIndexedDbStore(chatsDb);
    const cmAttachmentService = new ChatMessageAttachmentHttpService_1.ChatMessageAttachmentHttpService(cmAttachmentStore, chatServiceUrl, () => token);
    //chatRepo = new ChatMemRepository(false, cmdHub, evtHub, cmAttachmentService);
    chatRepo = new ChatIndexedDbRepository_1.ChatIndexedDbRepository(false, cmdHub, evtHub, cmAttachmentService, chatsDb);
    chatFactory = new ChatFactory_1.ChatFactory(false, chatRepo, cmdHub, evtHub, cmAttachmentService);
    exports.chatAppService = new ChatClientApplicationService_1.ChatClientApplicationService(exports.langyan, chatFactory, chatRepo, cmAttachmentService, cmdHub, evtHub);
    await exports.chatAppService.initAsync(userId, userName);
    //init session domain
    sessionRepo = new SessionMemRepository_1.SessionMemRepository();
    sessionFactory = new SessionClientFactory_1.SessionClientFactory(sessionRepo, exports.langyan, cmdHub, evtHub);
    exports.sessionAppService = new SessionClientApplicationService_1.SessionClientApplicationService(sessionFactory, sessionRepo, cmdHub, evtHub);
    exports.sessionAppService.initAsync(userId, userName);
    //init fudao domain
    fudaoRepo = new FudaoMemRepository_1.FudaoMemRepository();
    fudaoPassedTimeCounter = new FudaoPassedTimeCounter_1.FudaoPassedTimeCounter(fudaoRepo);
    fudaoSessionFacade = new FudaoSessionFacade_1.FudaoSessionFacade(exports.sessionAppService, evtHub, fudaoRepo);
    fudaoHttpCmdHubAdapter = new FudaoHttpCommandHubAdapter_1.FudaoHttpCommandHubAdapter(fudaoServiceUrl, cmdHub);
    fudaoFactory = new FudaoClientFactory_1.FudaoClientFactory(exports.chatAppService, fudaoPassedTimeCounter, fudaoSessionFacade, fudaoRepo, fudaoHttpCmdHubAdapter, evtHub);
    fudaoPassportService = new FudaoPassportService_1.FudaoPassportService(fudaoServiceUrl);
    exports.fudaoAppService = new FudaoClientApplicationService_1.FudaoClientApplicationService(fudaoPassportService, exports.chatAppService, fudaoFactory, fudaoRepo, fudaoHttpCmdHubAdapter, evtHub);
    const localFudaoUser = new FudaoUser_1.FudaoUser({
        Id: userId,
        Name: userName,
    });
    await exports.fudaoAppService.initAsync(localFudaoUser);
    fudaoEventToChatAdapter = new FudaoEventToChatAdapter_1.FudaoEventToChatAdapter(exports.chatAppService, exports.sessionAppService, exports.fudaoAppService, evtHub);
    await fudaoEventToChatAdapter.initAsync(localFudaoUser);
};
exports.terminateAsync = async () => {
    if (fudaoEventToChatAdapter) {
        await fudaoEventToChatAdapter.terminateAsync();
        fudaoEventToChatAdapter = null;
    }
    if (exports.fudaoAppService) {
        await exports.fudaoAppService.terminateAsync();
        exports.fudaoAppService = null;
    }
    if (exports.sessionAppService) {
        await exports.sessionAppService.terminateAsync();
        exports.sessionAppService = null;
    }
    if (exports.chatAppService) {
        await exports.chatAppService.terminateAsync();
        exports.chatAppService = null;
    }
    if (exports.userAppService) {
        await exports.userAppService.terminateAsync();
        exports.userAppService = null;
    }
    if (evtHub) {
        await evtHub.terminateAsync();
        evtHub = null;
    }
    if (cmdHub) {
        await cmdHub.terminateAsync();
        cmdHub = null;
    }
    if (exports.langyan) {
        await exports.langyan.terminateAsync();
    }
};
//# sourceMappingURL=index.js.map